"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JotaiStoreInjector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const data_injector_1 = require("../data-injector");
const component_1 = require("../../component");
const related_app_1 = require("./navigator/related-app");
const ready_state_1 = require("./dom/ready-state");
const remix_1 = require("./remix");
const JotaiStoreInjector = (props) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(data_injector_1.DataInjector, { ...props }), (0, jsx_runtime_1.jsx)(component_1.ServerContextInjector, {}), (0, jsx_runtime_1.jsx)(remix_1.RemixInjector, {}), (0, jsx_runtime_1.jsx)(ready_state_1.DOMStateInjector, {}), (0, jsx_runtime_1.jsx)(related_app_1.InstalledRelatedAppsInjector, {})] }));
};
exports.JotaiStoreInjector = JotaiStoreInjector;
